export default __webpack_public_path__ + "static/media/select-arrows.72a952d7.svg";